const ROUTES = require('./routes')
const STATES = require('./states')
const REQUISITION_STATUSES = require('./requisition-statuses')
const RESULT_TYPES = require('./result-types')
const TEST_TYPES = require('./test-types')
const EVENTS = require('./events')
const CONSULTATION_STATUSES = require('./consultation-statuses')

module.exports = {
  ROUTES,
  STATES,
  REQUISITION_STATUSES,
  RESULT_TYPES,
  TEST_TYPES,
  EVENTS,
  CONSULTATION_STATUSES
}
